import React from 'react';

const Logo = ({ className = "w-8 h-8", glow = true }) => {
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      {glow && (
        <div className="absolute inset-0 bg-sp-lime/20 blur-lg rounded-full animate-pulse"></div>
      )}
      <svg 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 w-full h-full drop-shadow-neon"
      >
        {/* Outer Hexagon Frame */}
        <path 
          d="M50 5L90 27.5V72.5L50 95L10 72.5V27.5L50 5Z" 
          stroke="currentColor" 
          strokeWidth="4" 
          className="text-sp-lime"
        />
        {/* Pilot Wings / Barcode Pattern */}
        <path 
          d="M30 40H70M30 50H70M30 60H50" 
          stroke="currentColor" 
          strokeWidth="6" 
          strokeLinecap="square"
          className="text-sp-lime"
        />
        {/* Central Radar Point */}
        <circle cx="50" cy="50" r="12" className="fill-sp-black stroke-sp-lime" strokeWidth="2" />
        <circle cx="50" cy="50" r="4" className="fill-sp-lime" />
      </svg>
    </div>
  );
};

export default Logo;